import { useState, useEffect } from 'react'
import { List, Link } from '@chakra-ui/react'

const NoticeList = ({ restore }) => {
  const [day, setDay] = useState(null)

  useEffect(() => {
    const today = new Date()
    setDay(today.getDate())
  }, [])

  return (
    <List.Root as="ul" listStyleType="disc" pl={8} pr={4} fontSize="xs">
      <List.Item>本コースは定期購入（自動継続）です。</List.Item>
      <List.Item>
        次回以降の決済日は毎月{day}日です。ただし、該当日がない月は月末最終日に自動決済されます。
        <br />
        （例：5月31日に登録した場合、6月は30日に決済されます。）
      </List.Item>
      <List.Item>次回以降のコインと継続ボーナスポイントは、自動決済日の翌日に付与されます。</List.Item>
      <List.Item>
        月額登録の解除は、<Link href="/user/monthly_course_unregister">月額解除ページ</Link>からコースごとに行ってください。
      </List.Item>
      <List.Item>コインは購入日を起算日として180日目まで有効です。</List.Item>
      <List.Item>ボーナスポイントは付与日を起算日として30日目まで有効です。</List.Item>

      {restore && (
        <List.Item>
          決済エラー（クレジットカードの有効期限切れ、限度額超過等）の理由は、大変お手数ですがカード発行会社または契約している携帯電話会社へお問い合わせください。
        </List.Item>
      )}
    </List.Root>
  )
}

export default NoticeList
